/**
 * Phonics Letter Teams L06 — 课程数据配置
 * L6 Blends fr, dr, gr
 *
 * 媒体资源基础路径（对应服务器 /media/phonics/lt06/）
 *
 * 统一数据结构：
 * {
 *   layout: '...',
 *   videos: [{ src, poster? }],
 *   lines: [{ en, audioEn }],
 * }
 */

const MEDIA_BASE = '/media/phonics/lt06';
const V = 'v1';

export const letterData = {
  title: 'L6 Blends fr, dr, gr',
  mediaBase: MEDIA_BASE,

  // P1: Watch the video (Part 1)
  part1Video: {
    src: `${MEDIA_BASE}/part1.mp4?${V}`,
  },

  // P2: Watch the video (Part 3)
  part3Video: {
    src: `${MEDIA_BASE}/part3.mp4?${V}`,
  },

  // P3: 静态复习图片
  reviewPic: {
    src: `${MEDIA_BASE}/review.png?${V}`,
  },

  // Story 1 (8句)
  // Story 2 (4句)
  // Story 3 (4句)
  storySections: [
    {
      label: 'Learn the story (1)',
      layout: 'story-video-left-lines-right',
      instructionAudio: `/media/phonics/lt01/audio_instruction_repeat_story.mp3`,
      titleCn: '跟读故事',
      instructionAudio: `/media/phonics/lt01/audio_instruction_repeat_story.mp3`,
      titleCn: '跟读故事',
      videos: [{ src: `${MEDIA_BASE}/story1.mp4?${V}` }],
      lines: [
        { en: 'Green plays his drum.', audioEn: `${MEDIA_BASE}/story1_1.mp3?${V}` },
        { en: 'A frog hops on his drum.', audioEn: `${MEDIA_BASE}/story1_2.mp3?${V}` },
        { en: 'A frog is in here!', audioEn: `${MEDIA_BASE}/story1_3.mp3?${V}` },
        { en: 'The pals run to see.', audioEn: `${MEDIA_BASE}/story1_4.mp3?${V}` },
        { en: 'But it hops in a crib.', audioEn: `${MEDIA_BASE}/story1_5.mp3?${V}` },
        { en: 'Grab that frog!', audioEn: `${MEDIA_BASE}/story1_6.mp3?${V}` },
        { en: 'The pals run to the crib.', audioEn: `${MEDIA_BASE}/story1_7.mp3?${V}` },
        { en: 'The frog hops away.', audioEn: `${MEDIA_BASE}/story1_8.mp3?${V}` },
      ],
    },
    {
      label: 'Learn the story (2)',
      layout: 'story-video-left-lines-right',
      instructionAudio: `/media/phonics/lt01/audio_instruction_repeat_story.mp3`,
      titleCn: '跟读故事',
      videos: [{ src: `${MEDIA_BASE}/story2.mp4?${V}` }],
      lines: [
        { en: 'Stop, frog!', audioEn: `${MEDIA_BASE}/story2_1.mp3?${V}` },
        { en: 'The frog is on the dress!', audioEn: `${MEDIA_BASE}/story2_2.mp3?${V}` },
        { en: 'The frog hops off the dress.', audioEn: `${MEDIA_BASE}/story2_3.mp3?${V}` },
        { en: 'I have a plan.', audioEn: `${MEDIA_BASE}/story2_4.mp3?${V}` },
      ],
    },
    {
      label: 'Learn the story (3)',
      layout: 'story-video-left-lines-right',
      instructionAudio: `/media/phonics/lt01/audio_instruction_repeat_story.mp3`,
      titleCn: '跟读故事',
      videos: [{ src: `${MEDIA_BASE}/story3.mp4?${V}` }],
      lines: [
        { en: 'The frog hops to some grapes.', audioEn: `${MEDIA_BASE}/story3_1.mp3?${V}` },
        { en: 'Green grabs the frog.', audioEn: `${MEDIA_BASE}/story3_2.mp3?${V}` },
        { en: 'He puts it in the grass.', audioEn: `${MEDIA_BASE}/story3_3.mp3?${V}` },
        { en: "Don't come in again!", audioEn: `${MEDIA_BASE}/story3_4.mp3?${V}` },
      ],
    },
  ],
};

export default letterData;
